import { Plus } from 'lucide-react'
import type { StakeholderTemplate } from '@bandos/shared'
import { TemplateCard } from './TemplateCard'
import {
  RosterPanel as StyledRosterPanel,
  RosterHeader,
  RosterScrollArea,
  RosterSection,
  RosterSectionHeader,
  RosterGrid,
  CreateNewCard,
  CreateNewIcon,
  CreateNewText,
} from '../styles/CharacterSelectionModalStyles'

interface RosterPanelProps {
  templates: StakeholderTemplate[]
  personalTemplates: StakeholderTemplate[]
  prebuiltTemplates: StakeholderTemplate[]
  selectedTemplate: StakeholderTemplate | null
  isTeamFull: boolean
  teamSize: number
  operatingIds: Set<string>
  brokenPortraits: Set<string>
  markPortraitBroken: (id: string) => void
  isTemplateInTeam: (id: string) => boolean
  isGeneratingPortrait: (id: string) => boolean
  onCardSelect: (template: StakeholderTemplate) => void
  onEditClick: (template: StakeholderTemplate, e: React.MouseEvent) => void
  onAddToTeam: (template: StakeholderTemplate, e: React.MouseEvent) => void
  onCreateNew: () => void
}

export function RosterPanel({
  templates,
  personalTemplates,
  prebuiltTemplates,
  selectedTemplate,
  isTeamFull,
  teamSize,
  operatingIds,
  brokenPortraits,
  markPortraitBroken,
  isTemplateInTeam,
  isGeneratingPortrait,
  onCardSelect,
  onEditClick,
  onAddToTeam,
  onCreateNew,
}: RosterPanelProps) {
  return (
    <StyledRosterPanel>
      <RosterHeader>Roster ({templates.length})</RosterHeader>
      <RosterScrollArea>
        {prebuiltTemplates.length > 0 && (
          <RosterSection>
            <RosterSectionHeader>Templates ({prebuiltTemplates.length})</RosterSectionHeader>
            <RosterGrid>
              {prebuiltTemplates.map((template) => (
                <TemplateCard
                  key={template.id}
                  template={template}
                  isInTeam={isTemplateInTeam(template.id)}
                  isTeamFull={isTeamFull}
                  isSelected={selectedTemplate?.id === template.id}
                  isOperating={operatingIds.has(template.id)}
                  isGenerating={isGeneratingPortrait(template.id)}
                  teamSize={teamSize}
                  brokenPortraits={brokenPortraits}
                  markPortraitBroken={markPortraitBroken}
                  onSelect={onCardSelect}
                  onEdit={onEditClick}
                  onAddToTeam={onAddToTeam}
                />
              ))}
            </RosterGrid>
          </RosterSection>
        )}

        <RosterSection>
          <RosterSectionHeader>Your Creations ({personalTemplates.length})</RosterSectionHeader>
          <RosterGrid>
            {personalTemplates.map((template) => (
              <TemplateCard
                key={template.id}
                template={template}
                isInTeam={isTemplateInTeam(template.id)}
                isTeamFull={isTeamFull}
                isSelected={selectedTemplate?.id === template.id}
                isOperating={operatingIds.has(template.id)}
                isGenerating={isGeneratingPortrait(template.id)}
                teamSize={teamSize}
                brokenPortraits={brokenPortraits}
                markPortraitBroken={markPortraitBroken}
                onSelect={onCardSelect}
                onEdit={onEditClick}
                onAddToTeam={onAddToTeam}
              />
            ))}
            <CreateNewCard onClick={onCreateNew}>
              <CreateNewIcon>
                <Plus size={24} />
              </CreateNewIcon>
              <CreateNewText>Create New</CreateNewText>
            </CreateNewCard>
          </RosterGrid>
        </RosterSection>
      </RosterScrollArea>
    </StyledRosterPanel>
  )
}
